export default __webpack_public_path__ + "static/media/about4.324cfbc9.jpg";